import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/objectWithoutPropertiesLoose';
import * as React from 'react';
import { StyleSheet } from 'aphrodite';
import { addStyle } from '@khanacademy/wonder-blocks-core';

const viewportPixelsForSize = size => ({
  small: 16,
  medium: 24,
  large: 48,
  xlarge: 96
})[size];

const _excluded = ["color", "icon", "size", "style", "testId", "className", "role"];
const StyledSpan = addStyle("span");
const PhosphorIcon = React.forwardRef(function PhosphorIcon(props, ref) {
  const {
      color = "currentColor",
      icon,
      size = "small",
      style,
      testId,
      className,
      role
    } = props,
    sharedProps = _objectWithoutPropertiesLoose(props, _excluded);
  const pixelSize = viewportPixelsForSize(size);
  const classNames = `${className != null ? className : ""}`;
  const iconStyles = _generateStyles(color, pixelSize);
  return React.createElement(StyledSpan, _extends({}, sharedProps, {
    className: classNames,
    style: [styles.svg, iconStyles.icon, {
      maskImage: `url(${icon})`
    }, style],
    "data-testid": testId,
    ref: ref,
    role: (role != null ? role : sharedProps["aria-label"]) ? "img" : undefined
  }));
});
const dynamicStyles = {};
const _generateStyles = (color, size) => {
  const iconStyle = `${color}-${size}`;
  if (styles[iconStyle]) {
    return styles[iconStyle];
  }
  const newStyles = {
    icon: {
      backgroundColor: color,
      width: size,
      height: size
    }
  };
  dynamicStyles[iconStyle] = StyleSheet.create(newStyles);
  return dynamicStyles[iconStyle];
};
const styles = StyleSheet.create({
  svg: {
    display: "inline-block",
    verticalAlign: "text-bottom",
    flexShrink: 0,
    flexGrow: 0,
    maskSize: "100%",
    maskRepeat: "no-repeat",
    maskPosition: "center"
  }
});
PhosphorIcon.displayName = "PhosphorIcon";

export { PhosphorIcon };
